import React, { Component } from 'react';
import { Field } from 'redux-form';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { DisabledInputField } from '../Common/inputField';
import PriceFormatter from '../Common/priceFormatter';
import CashFormatter from '../Common/cashFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';
import DateFormatter from '../Common/dateFormat';
import { toFromDates } from '../Common/cleanDates';
import { ROOT_URL, companyCodeTitle } from '../../actions/root_url';

momentLocalizer(moment);

const getBsStyle = (input, value) => ((input === value) ? 'success' : 'primary');

let renderRadios = props => {
    const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2')
    return (
      <ButtonToolbar className='radio-filter-buttons'>
        <Button bsStyle={getBsStyle(props.input.value, '1')}>
          <div className='radio'>
            <label for='today-radio-filter'>
              <input {...props.input} id='today-radio-filter' type='radio' name='dateFilterRadios' value='1' onClick={() =>{ props.fetchReceiveHistoryByDetails(1); }} checked={props.input.value === '1'}/>
              <Translate value="today" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '7')}>
          <div className='radio'>
            <label for='sevenDay-radio-filter'>
              <input {...props.input} id='sevenDay-radio-filter' type='radio' name='dateFilterRadios' value='7' onClick={() =>{ props.fetchReceiveHistoryByDetails(7); }} checked={props.input.value === '7'}/>
              7 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '30')}>
          <div className='radio'>
            <label for='thirtyDay-radio-filter'>
              <input {...props.input} id='thirtyDay-radio-filter' type='radio' name='dateFilterRadios' value='30' onClick={() =>{ props.fetchReceiveHistoryByDetails(30); }} checked={props.input.value === '30'}/>
              30 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '90')}>
          <div className='radio'>
            <label for='ninetyDay-radio-filter'>
              <input {...props.input} id='ninetyDay-radio-filter' type='radio' name='dateFilterRadios' value='90' onClick={() =>{ props.fetchReceiveHistoryByDetails(90); }} checked={props.input.value === '90'}/>
              90 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '-1')}>
          <div className='radio'>
            <label for='dateRange-radio-filter'>
              <input {...props.input} id='dateRange-radio-filter' type='radio' name='dateFilterRadios' value='-1' checked={props.input.value === '-1'}/>
               <Translate value="date_range" />
            </label>
          </div>
        </Button>
        <Button bsStyle='primary'>
          <Field name='FromDate' placeholder={'Start'} component={ (props.input.value === '-1') ? DatePicker : DisabledDatePicker }/>
        </Button>
        <Button bsStyle='primary'>
          <Field name='ToDate' placeholder={'End'} component={ (props.input.value === '-1') ? DatePicker : DisabledDatePicker }/>
        </Button>
        <Button
          bsStyle='primary'
          type='submit'
          onClick={() =>{ props.fetchReceiveHistoryByDetails(); }}>
          <em className='fa fa-search' />
        </Button>
      </ButtonToolbar>
    )
}

class PurchasePaymentList extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage,

            createOpen: false,

            tableData: {
              rows: [],
              selectedRows: null,
              filters: {},
              sortColumn: null,
              sortDirection: null,
            },
            gourpOpen: false,
            total: 0,
            balance: 0,
            rowsCount: 0,
        };

        this.handleResize = this.handleResize.bind(this);

        this.openCreate = this.openCreate.bind(this);
        this.closeCreate = this.closeCreate.bind(this);
        this.receiveDetail = this.receiveDetail.bind(this);
    }

    componentWillMount() {
      this.props.setDefaultDays('purchasePaymentList');
      this.props.fetchReceiveHistoryByDate('1900-01-01', '3000-01-01', '7', true);
    }

    componentDidMount() {
       document.title = companyCodeTitle;
        window.addEventListener('resize', this.handleResize);
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.tableData !== this.state.tableData) {
        this.setState({ rowsCount: Data.Selectors.getRows(this.state.tableData).length });
      }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once purchaseOrders is ready, reset state.

    componentWillReceiveProps(nextProps) {
      if (!nextProps.Days) {
        this.props.setDefaultDays('purchasePaymentList');
      }
      if (nextProps.currentReceiveHistory && nextProps.currentReceiveHistory != this.props.currentReceiveHistory) {
        let receives = nextProps.currentReceiveHistory.Invoices;
        const total = nextProps.currentReceiveHistory.TotalFinalPrice;
        const balance = nextProps.currentReceiveHistory.TotalBalance;
        // receives.map(
        //   receive => {
        //       receive['VendorName'] = receive.Purchase.Vendor.Name;
        //   }
        // )
        const tableData = { ...this.state.tableData, rows: receives };
        this.setState({
            tableData,
            total,
            balance,
        });
      }
    }

    openCreate() { this.setState({ createOpen: true }); }
    closeCreate() { this.setState({ createOpen: false }); }

    receiveDetail(e) {
      e.preventDefault();
      const currentReceiveHistory = this.state.tableData.selectedRows[0];
      this.props.resetCurrentReceiveHistory();
      this.props.selectReceiveHistory(currentReceiveHistory);
      this.context.router.push('/purchasePayment/'+currentReceiveHistory.PONum);
    }


    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage });
    }

    // Set purchaseOrders being selected to be currentReceive and navigate user to the edit page

    setCurrentReceive(e) {
        e.preventDefault();
        const currentReceive = this.state.tableData.selectedRows[0];
        this.props.selectReceiveHistory(currentReceive);
    }

    clickNew(e) {
        e.preventDefault();
        // this.props.resetCurrentReceive();
        this.context.router.push('/inventories/receive/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className='alert alert-danger'>{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 930) ? 460 : 460;

            const getRows = () => {
                return Data.Selectors.getRows(this.state.tableData);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const tableData = { ...this.state.tableData, selectedRows: rows };
                this.setState({ tableData });
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state.tableData, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({ tableData: state });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.tableData.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const tableData = { ...this.state.tableData, filters: newFilters };
                this.setState({ tableData });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className='label label-success'><Translate value="enabled" /></span>;
                    else return <span className='label label-danger'><Translate value="disable" /></span>;
                }
            });

            const onRowClick = (rowIdx, row) => {
                if(rowIdx < 0)  return;
                this.props.resetCurrentReceiveHistory();
                this.props.selectReceiveHistory(row);
                // this.context.router.push('/inventories/receive/new')
            }

            // Column difinition

            const columns = [
              {
                  key: 'PONum',
                  name: <Translate value="po_num" />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  filterable: true,
              },
              {
                  key: 'WarehouseReceiveNum',
                  name: <Translate value="receive_num" />,
                  resizable: true,
                  sortable: true,
                  width: 105,
                  filterable: true,
              },
              {
                  key: 'CreateTime',
                  name: <Translate value="po_date" />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  filterable: true,
                  formatter: DateFormatter,
              },
              {
                  key: 'PostingDate',
                  name: <Translate value="posting_date" />,
                  resizable: true,
                  sortable: true,
                  width: 130,
                  filterable: true,
                  formatter: DateFormatter,
              },
              {
                  key: 'InvoiceNum',
                  name: <Translate value="invoice_no" />,
                  resizable: true,
                  sortable: true,
                  width: 110,
                  filterable: true,
              },
              {
                  key: 'VendorName',
                  name: <Translate value="vendor_name" />,
                  resizable: true,
                  sortable: true,
                  width: 190,
                  filterable: true,
              },
              {
                  key: 'FinalPrice',
                  name: <Translate value="final_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 75,
                  filterable: true,
                  formatter: CashFormatter,
              },
              {
                  key: 'UnpaidAmount',
                  name: <Translate value="balance" />,
                  resizable: true,
                  sortable: true,
                  width: 75,
                  filterable: true,
                  formatter: CashFormatter,
              },
              {
                  key: 'Create_Username',
                  name: <Translate value="purchaser" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
              },
              {
                  key: 'ArrivalStatus',
                  name: <Translate value="status" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true,
              },
              {
                  key: 'PaymentStatus',
                  name: <Translate value="pmt_status" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'CheckNum',
                  name: <Translate value="check_num" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true,
              },
              {
                  key: 'Note',
                  name: <Translate value="note" />,
                  resizable: true,
                  sortable: true,
                  width: 95,
                  filterable: true,
              },
              {
                  key: 'Owner',
                  name: <Translate value="owner" />,
                  resizable: true,
                  sortable: true,
                  width: 95,
                  filterable: true,
              },
            ]

            return (
                //React Table Purchase Payment List
              <div>
                <Row>
                  <Col xs={ 12 }>
                    <div id="PurchasePaymentList-dataGrid1">
                      <ReactDataGrid
                        rowKey='WarehouseReceive_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        headerRowHeight={45}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={tableHeight}
                        enableRowSelect='single'
                        onRowClick={onRowClick}
                        onRowSelect={onRowSelect}
                        />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={ 12 }>
                    <div>
                      <Col xs={3}>
                        <label style={{ 'display': 'inline-flex', 'margin-top': '15px' }}>
                          <Translate value="rows" />:&nbsp;
                          <span className="font-color-orange">{ this.state.rowsCount }</span>
                        </label>
                      </Col>
                      <Col xs={4}>
                        <label style={{ 'display': 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' }}>
                          <span style={{ 'margin-top': '3px' }}>
                            <Translate value="final_total" /><span className="dollar-sign"> $$</span>:&nbsp;
                          </span>
                          <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.total)}` || 0}/>
                        </label>
                      </Col>
                      <Col xs={4}>
                        <label style={{ 'display': 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' }}>
                          <span style={{ 'margin-top': '3px' }}>
                            <Translate value="balance_total" /><span className="dollar-sign"> $$</span>:&nbsp;
                          </span>
                          <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.balance)}` || 0}/>
                        </label>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </div>
            )
        }
    }

    renderDatePickers() {
      if(this.props.Days == -1)
        return (
          <div className='form-group date-picker-positioner'>
            <label className='col-xs-2 from-label col-xs-offset-5'>
              <Translate value="from" />
            </label>
            <div className='col-xs-2 control-date-picker'>
              <Field name='FromDate' component={DatePicker} disabled={this.props.Days !== '-1'} />
            </div>
            <label className='col-xs-1 to-label'>
              <Translate value="to" />
            </label>
            <div className='col-xs-2 control-date-picker'>
              <Field name='ToDate' component={DatePicker} disabled={this.props.Days !== '-1'} />
            </div>
          </div>
        )
      // else return(
      //   <Row>
      //     <Col xs={ 10 }></Col>
      //     <Col xs={ 2 }>
      //       <Button
      //         bsStyle='primary'
      //         onClick={() =>{ this.fetchReceiveHistoryByDetails(); }}><Translate value="submit" />
      //       </Button>
      //     </Col>
      //   </Row>
      // )
    }

    fetchReceiveHistoryByDetails(days) {
      let dateRange = -1;
      let FromDate = '1900-01-01';
      let ToDate = '3000-01-01';

      if (this.props.FromDate != null)
        FromDate = this.formatDate(this.props.FromDate);

      if (this.props.ToDate != null)
        ToDate = this.formatDate(this.props.ToDate);
      // console.log(dateRange);
      if (days != null) {
        dateRange = days;
      }
      this.props.fetchReceiveHistoryByDate(FromDate, ToDate, dateRange, true);
    }

    formatDate(date) {
      let formattedDate = date.getFullYear() + '-';

      formattedDate += date.getMonth()+1 + '-';
      if (date.getDate() < 10) {
        formattedDate += '0' + date.getDate();
      } else {
        formattedDate += date.getDate();
      }

      return formattedDate;
    }

    renderPrint() {
      let warehouseReceiveNum = this.state.tableData.selectedRows && this.state.tableData.selectedRows.length == 1 && this.state.tableData.selectedRows[0].WarehouseReceiveNum;
      const warehouseReceiveID = this.state.tableData.selectedRows && this.state.tableData.selectedRows[0] && this.state.tableData.selectedRows[0].WarehouseReceive_id;
      if (!warehouseReceiveNum || !warehouseReceiveID) {
        return;
      }
      let url = ROOT_URL + 'v1/warehouse/receive/print/' + warehouseReceiveNum + '?Bearer=' + localStorage.getItem('token');
      return(
        <Button
          bsStyle='primary'
          type='button'
          href={url}>
          <em className='fa fa-print' /><Translate value="print" />
        </Button>
      )
    }

    getDateFromFilter() {
      const { FromDate, ToDate, Days } = this.props;
      // let fromDate = FromDate ? moment(FromDate).format('YYYY-MM-DD') : moment().subtract(7, 'days').format('YYYY-MM-DD');
      // let toDate = ToDate ? moment(ToDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
      let fromDate;
      let toDate;
      if (Days !== '-1') {
        fromDate = moment().subtract(parseInt(Days, 10), 'days').format('YYYY-MM-DD');
        toDate = moment().format('YYYY-MM-DD');
      } else {
        fromDate = FromDate ? moment(FromDate).format('YYYY-MM-DD') : moment().subtract(7, 'days').format('YYYY-MM-DD');
        toDate = ToDate ? moment(ToDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
      }
      return { fromDate, toDate };
    }

    renderExportButton() {
      const { FromDate, ToDate, Days } = this.props;
      const dates = toFromDates(Days, FromDate, ToDate);
      const fromDate = `startdate=${dates.fromDate}`;
      const toDate = `enddate=${dates.toDate}`;
      const token = `Bearer=${localStorage.getItem('token')}`;
      const url = `${ROOT_URL}v1/dashboard/purchasecsv/?${fromDate}&${toDate}&${token}`;
      return (
        <Button
          bsStyle='success'
          type='button'
          href={url}
        >
          <em className='fa fa-download' /><Translate value="export" />
        </Button>
      );
    }

    render() {
        let createDialogStyle = {
            width: '400px',
            marginLeft: '-10%',
        };
        let warehouseReceive_id = this.state.tableData.selectedRows && this.state.tableData.selectedRows[0] && this.state.tableData.selectedRows[0].WarehouseReceive_id;
        warehouseReceive_id = warehouseReceive_id || '';
        let url = ROOT_URL + 'v1/warehouse/receive/print/' + warehouseReceive_id + '?Bearer=' + localStorage.getItem('token');
        let height = (this.state.tableHeight + 70).toString();
        let tableCollapseFix = {height: height}
        return (
          //---------------
          // Begin HTML
          //---------------
          <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="ar_slashsign_ap" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active='true'>
                  <Translate value="purchase_report" />
                </Breadcrumb.Item>
              </Breadcrumb>

              <ButtonToolbar>
                { this.renderExportButton() }
              </ButtonToolbar>

              <Grid id='purchase-payment'>
                {/* <h1><Translate value="purchase_report" /></h1> */}
                <Row>
                  <Col xs={ 12 }>
                    <Panel id='date-range-picker' className='form-horizontal'>
                      <Row>
                        <Col xs={ 1 }>
                          <h3 className='filter-title text-nowrap'><Translate value="posting_date" /><span className='colon'>:</span></h3>
                        </Col>
                        <Col xs={ 11 }>
                          <Field name='Days' component={ renderRadios } fetchReceiveHistoryByDetails={this.fetchReceiveHistoryByDetails.bind(this)} />
                        </Col>
                      </Row>
                    </Panel>
                  </Col>
                </Row>

                <Row>
                  <Col xs={ 12 }>
                    <Panel className='position-relative table-collapse-fix'>
                      <ButtonToolbar className='table-buttons'>
                        <Button
                          bsStyle='primary'
                          disabled={!this.state.tableData.selectedRows || this.state.tableData.selectedRows.length != 1 || !warehouseReceive_id}
                          onClick={this.receiveDetail}>
                          <em className='fa fa-file-text' />
                          <Translate value="detail" />
                        </Button>
                        {this.renderPrint()}
                      </ButtonToolbar>
                      {this.renderTable() }
                    </Panel>
                  </Col>
                </Row>
              </Grid>
          </ContentWrapper>
          //---------------
          // End HTML
          //---------------

        );
    }
}



export default PurchasePaymentList;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchasePaymentList.jsx